import { UserProfileResponseService } from "../../services/user/UserTypes.type";
import { SET_PROFILE_USER } from "./actionTypes";

export const setProfileUser = (data: UserProfileResponseService) => ({
  type: SET_PROFILE_USER,
  payload: data,
});
